$(document).on("click", ".js-trip", function () {
  let ajaxUrl = $(this).data("ajax-url");
  $("#booking .booking-form").attr("ajax-url", ajaxUrl);
  getJsonData(ajaxUrl);
});

// для проверки функционала получения инфы об автобусах

// function getJsonData(ajaxUrl) {
//   busBooking({
//     "id-trip": "4108",
//     tickets: 1,
//     userIDAgreement: true,
//     restrictions: {
//       food: "06-28-2022 07:45:00",
//       passport: "06-26-2022 07:45:00",
//     },
//     buses: {
//       sprinter: { visible: true, reserved: [], occupied: [], booked: { 1: 7 } },
//       higer: {
//         visible: true,
//         reserved: [],
//         occupied: ["20", "24", "23"],
//         booked: { 1: 16 },
//       },
//     },
//     seats: {
//       1: {
//         fullName: "",
//         birthDay: "1",
//         birthMonth: "1",
//         birthYear: "new Date().getFullYear()",
//         passport: "",
//         passportDay: "1",
//         passportMonth: "1",
//         passportYear: "new Date().getFullYear()",
//         foodType: 1,
//         foodComment: "",
//         ticketId: { higer: 112, sprinter: 113 },
//       },
//     },
//   });
// }

function getJsonData(ajaxUrl) {
  $.getJSON(ajaxUrl, function (data) { }).done(function (data) {
    busBooking(data);
  });
}

function postJsonData(json, ajaxUrl) {
  $.ajax({
    url: ajaxUrl,
    data: JSON.stringify(json),
    dataType: "json",
    contentType: "application/json",
    method: "POST",
    success: function (data) {
      checkErrors(data);
    },
  });
}

function checkErrors(bus) {
  let popupTitle = $(".booking-popup__title");
  let popupMessage = $(".booking-popup__message");

  popupTitle.text("");
  popupMessage.text("");

  if (
    !bus?.errors ||
    (Object.keys(bus.errors).length === 0 && bus.errors.constructor === Object)
  ) {
    $.magnificPopup.close();
    popupTitle.text("Спасибо!");
    popupMessage.text("Ваши данные сохранены!");
    $(".thanks-popup").fadeIn();
  } else {
    busBooking(bus);
    popupTitle.text("Внимание!");
    $(".booking-popup").fadeIn();

    if (bus.errors.buses?.sprinter) {
      popupMessage.append(
        `<div class="booking-popup__bus">В автобусе <span>Sprinter</span></div>`
      );
      for (let [place, errorText] of Object.entries(
        bus.errors.buses["sprinter"]
      )) {
        popupMessage.append(
          `<div class="booking-popup__error">место <span>${place}:  </span> ${errorText}</div>`
        );
      }
    }

    if (bus.errors.buses?.higer) {
      popupMessage.append(
        `<div class="booking-popup__bus">В автобусе <span>Higer</span></div>`
      );
      for (let [place, errorText] of Object.entries(
        bus.errors.buses["higer"]
      )) {
        popupMessage.append(
          `<div class="booking-popup__error">место <span>${place}:  </span> ${errorText}</div>`
        );
      }
    }

    if (bus.errors?.other) {
      popupMessage.append(
        `<div class="booking-popup__error">${bus.errors["other"]}</div>`
      );
    }
  }
}

function busBooking(bus) {
  const totalTickets = bus.tickets,
    bookedClients = $(".booking-clients"),
    sumbitArea = $("#" + bus.busType).find(".booking-submit"),
    sprinter = bus.buses["sprinter"],
    higer = bus.buses["higer"],
    sprinterArea = $(".booking-sprinter"),
    higerArea = $(".booking-higer"),
    sprinterScheme = sprinterArea.find(".booking-bus svg"),
    higerScheme = higerArea.find(".booking-bus svg"),
    bookingInfo = $(".booking-clients"),
    bookingSubmit = $(".booking-submit"),
    sprinterSeats = 20,
    sprinterShow = sprinter["visible"],
    higerShow = higer["visible"],
    isEmtySeats =
      Object.keys(bus.seats).length === 0 && bus.seats.constructor === Object,
    sprinterVisible = sprinter.visible,
    preloader = $(".booking-preloader"),
    attent = $(".booking-attention");

  setTimeout(() => {
    preloader.fadeOut(500);
  }, 750);

  sprinterArea.hide();

  !higerShow ? higerArea.hide() : higerArea.show();

  function getPlaceStatus() {
    for (let key of Object.keys(bus.buses)) {
      let busType = bus.buses[`${key}`];
      let busSection = $(`.booking-${key}`);
      let busScheme = $(`.booking-${key} .booking-bus svg`);

      for (let i = 0; i < busType.reserved.length; i++) {
        busScheme
          .find(`.seat[data-seat='${busType.reserved[i]}']`)
          .attr("data-status", "reserved")
          .addClass("is-reserved");
      }

      for (let i = 0; i < busType.occupied.length; i++) {
        busScheme
          .find(`.seat[data-seat='${busType.occupied[i]}']`)
          .attr("data-status", "occupied")
          .addClass("is-occupied");
      }

      if (totalTickets) {
        for (let [id, place] of Object.entries(busType.booked)) {
          busScheme
            .find(`.seat[data-seat='${place}']`)
            .attr("data-status", "booked")
            .addClass("is-booked")
            .attr("data-user", id);

          $("<div/>", {
            class: `${key}-ticket booking-ticket`,
            "data-bus": key,
            "data-ticket": place,
            "data-user": id,
            html: `
						<div class="booking-ticket__wrap">
							<div class="booking-ticket__place">
								<span class="booking-ticket__title">Место</span>
								<span class="booking-ticket__number"><i>${place}</i></span>
							</div>
							<div class="booking-ticket__close js-removeTicket 12"></div>
						</div>
						`,
          }).appendTo(`.booking-${key} .booking-tickets`);
        }
      }

      if (sprinterShow && higerShow) {
        $(".booking-sprinter .booking-choice__limit .taken").text(
          Object.keys(bus.buses["sprinter"].booked).length
        );
        $(".booking-higer .booking-choice__limit .taken").text(
          Object.keys(bus.buses["higer"].booked).length
        );
      }
      if (sprinterShow) {
        $(".booking-sprinter .booking-choice__limit .taken").text(
          Object.keys(bus.buses["sprinter"].booked).length
        );
      }
      if (higerShow) {
        $(".booking-higer .booking-choice__limit .taken").text(
          Object.keys(bus.buses["higer"].booked).length
        );
      }
      busSection.find(".booking-choice__limit .total").text(totalTickets);

      $(".js-removeTicket").off();
      $(".js-removeTicket").on("click", function () {
        let seatNumber = $(this).closest(".booking-ticket").data("ticket");
        let seat = $(this)
          .parents(".booking-bus")
          .find(`[data-seat=${seatNumber}]`);
        freePlace(seat);
      });
    }

    if (isEmtySeats) {
      getPlaceBlank();
    } else {
      getPlaceInfo();
    }
  }

  function getPlaceInfo() {
    let seats = bus.seats;
    let bookedTickets = 0;

    // for ( let userID of Object.keys(seats)) {
    for (let userID = 1; userID <= totalTickets; userID++) {
      let user = bus.seats[userID];

      if (bus.seats[userID] != undefined) {
        let daySelect = "";
        let yearSelect = "";

        if (sprinter.booked[userID] == undefined)
          sprinter.booked[userID] = "не выбрано";
        if (higer.booked[userID] == undefined)
          higer.booked[userID] = "не выбрано";

        for (let d = 1; d <= 31; d++) {
          daySelect += `<option value="${d}">${d}</option>`;
        }

        for (let y = new Date().getFullYear(); y >= 1901; y--) {
          yearSelect += `<option value="${y}">${y}</option>`;
        }

        $("<div/>", {
          class: "booking-client",
          id: "participant-" + userID,
          html: `
              <div class="booking-client__row">
                <div class="booking-client__title" data-participant=${userID}>Участник
                  <div class="booking-client__num">${bookedTickets + 1}</div>
                  <div class="booking-client__sprinter is-hidden">Sprinter: <span>${sprinter.booked[userID]
            }</span> место</div>
                  <div class="booking-client__higer">Higer: <span>${higer.booked[userID]
            }</span> место</div>
    					  </div>
                <div class="booking-client__radios">
                  <div class="booking-row">
                    <div class="booking-col">
                      <label class="js-show-data">
                        <input class="cust_radio__input" id="data_${userID}_1" type="radio" name="data_${userID}" checked>
                        <div class="cust_radio__label">заполнить данные сейчас</div>
                      </label>
                    </div>
                    <div class="booking-col">
                      <label class="js-hide-data">
                        <input class="cust_radio__input" id="data_${userID}_2" type="radio" name="data_${userID}">
                        <div class="cust_radio__label">отправить куратору на e-mail</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>


    					<div class="booking-field booking-data">
    						<div class="booking-placeholder">Ф.И.О. полностью</div>
    						<input type="text" name="booking_name_${userID}" value="${user.fullName
            }" class="js-letters buyer-name" required>
    					</div>

    					<div class="booking-row cols-3 booking-data">
    						<div class="booking-col">
    							<div class="booking-placeholder">Дата рождения</div>
    							<div class="booking-date buyer-birthday">
    								<select class="booking-select__day buyer-day" name="birth-day">
                                        ${daySelect}
    								</select>
    								<select class="booking-select__month buyer-month" name="birth-month_${userID}">
    									<option value="1">январь</option>
    									<option value="2">февраль</option>
    									<option value="3">март</option>
    									<option value="4">апрель</option>
    									<option value="5">май</option>
    									<option value="6">июнь</option>
    									<option value="7">июль</option>
    									<option value="8">август</option>
    									<option value="9">сентябрь</option>
    									<option value="10">октябрь</option>
    									<option value="11">ноябрь</option>
    									<option value="12">декабрь</option>
    								</select>
    								<select class="booking-select__year buyer-year" name="birth-year_${userID}">
                                        ${yearSelect}
                                    </select>
    							</div>
    						</div>
    						<div class="booking-col">
    							<div class="booking-placeholder">Серия и номер паспорта</div>
    							<div class="booging-field">
    								<input type="text" name="passport_${userID}" value="${user.passport
            }" class="js-passport buyer-passport-number" required>
    							</div>
    						</div>
    						<div class="booking-col">
    							<div class="booking-placeholder">Дата выдачи паспорта</div>
    							<div class="booking-date buyer-passport">
    								<select class="booking-select__day buyer-passport-day" name="passport-day_${userID}">
                                        ${daySelect}
    								</select>
    								<select class="booking-select__month buyer-passport-month" name="passport-month_${userID}">
    									<option value="1">январь</option>
    									<option value="2">февраль</option>
    									<option value="3">март</option>
    									<option value="4">апрель</option>
    									<option value="5">май</option>
    									<option value="6">июнь</option>
    									<option value="7">июль</option>
    									<option value="8">август</option>
    									<option value="9">сентябрь</option>
    									<option value="10">октябрь</option>
    									<option value="11">ноябрь</option>
    									<option value="12">декабрь</option>
    								</select>
    								<select class="booking-select__year buyer-passport-year" name="passport-year_${userID}">
                                        ${yearSelect}
    								</select>
    							</div>
    						</div>
    					</div>

    					<div class="booking-field">
    						<div class="booking-placeholder">Тип питания</div>
    						<div class="booking-row">
    							<div class="booking-col">
    								<div for="food_${userID}_1" class="buyer-meal js-standard" data-meal="1">
    									<input class="cust_radio__input" id="food_${userID}_1" type="radio" name="food_${userID}" checked>
    									<label for="food_${userID}_1" class="cust_radio__label">стандартный</label>
    								</div>
    							</div>
    							<div class="booking-col">
    								<div for="food_${userID}_2" class="buyer-meal js-vegan" data-meal="2">
    									<input class="cust_radio__input" id="food_${userID}_2" type="radio" name="food_${userID}">
    									<label for="food_${userID}_2" class="cust_radio__label">вегетарианский (или иное)</label>
    								</div>
    							</div>
    						</div>
    					</div>

    					<div class="booking-field booking-comment">
    						<textarea class="buyer-meal-comment" name="comment_1" placeholder="Укажите, пожалуйста, существенные ограничения в питании, если есть (аллергия, непереносимость, веганское, вегетарианское и т.д.)">${user.foodComment
            }</textarea>
    					</div>
    		`,
        }).appendTo(bookedClients);

        let buyerBirthday = $("#participant-" + userID).find(".buyer-birthday");
        let buyerPassport = $("#participant-" + userID).find(".buyer-passport");
        let buyerMeal = $("#participant-" + userID).find(
          `.buyer-meal[data-meal=${user.foodType}] .cust_radio__input`
        );

        buyerBirthday
          .find(`.booking-select__day option[value=${user.birthDay}]`)
          .attr("selected", "selected");
        buyerBirthday
          .find(`.booking-select__month option[value=${user.birthMonth}]`)
          .attr("selected", "selected");
        buyerBirthday
          .find(`.booking-select__year option[value=${user.birthYear}]`)
          .attr("selected", "selected");

        buyerPassport
          .find(`.booking-select__day option[value=${user.passportDay}]`)
          .attr("selected", "selected");
        buyerPassport
          .find(`.booking-select__month option[value=${user.passportMonth}]`)
          .attr("selected", "selected");
        buyerPassport
          .find(`.booking-select__year option[value=${user.passportYear}]`)
          .attr("selected", "selected");

        buyerMeal.attr("checked", "checked");

        if (user.foodType === 2) {
          $("#participant-" + userID)
            .find(".booking-comment")
            .slideDown(100);
        }

        if (!jQuery.isEmptyObject(bus.restrictions)) {
          const passportDate = new Date(bus?.restrictions["passport"]),
            foodDate = new Date(bus.restrictions["food"]),
            passportExpired = new Date() >= passportDate,
            foodExpired = new Date() >= foodDate;

          if (bus?.seats[1].passport === "") {
            setTimeout(function () {
              $(".js-hide-data").find("input").trigger("change");
              $(".js-hide-data").find("input").attr("checked", true);
            }, 300);
          }

          if (passportExpired)
            $(".booking-client__radios input").attr("disabled", true);
          $(".booking-client__radios label").addClass("disabled");
          $(".booking-data input").attr("disabled", true);
          $(".booking-data select").attr("disabled", true);

          if (passportExpired) {
            $(".buyer-meal-comment").attr("disabled", true);
            $(".buyer-meal").addClass("disabled");
          }
        }
      } else {
        let daySelect = "";
        let yearSelect = "";

        for (let d = 1; d <= 31; d++) {
          daySelect += `<option value="${d}">${d}</option>`;
        }

        for (let y = new Date().getFullYear(); y >= 1901; y--) {
          yearSelect += `<option value="${y}">${y}</option>`;
        }

        $("<div/>", {
          class: "booking-client",
          id: "participant-" + userID,
          html: `
    					<div class="booking-client__row">
                <div class="booking-client__title" data-participant=${userID}>Участник
                  <div class="booking-client__num">${bookedTickets + 1}</div>
                  <div class="booking-client__sprinter">Sprinter: <span>не выбрано</span> место</div>
                  <div class="booking-client__higer">Higer: <span>не выбрано</span> место</div>
                </div>
                <div class="booking-client__radios">
                  <div class="booking-row">
                    <div class="booking-col">
                      <label class="js-show-data">
                        <input class="cust_radio__input" id="data_${userID}_1" type="radio" name="data_${userID}" checked>
                        <div class="cust_radio__label">заполнить данные сейчас</div>
                      </label>
                    </div>
                    <div class="booking-col">
                      <label class="js-hide-data">
                        <input class="cust_radio__input" id="data_${userID}_2" type="radio" name="data_${userID}">
                        <div class="cust_radio__label">отправить куратору на e-mail</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

    					<div class="booking-field booking-data">
    						<div class="booking-placeholder">Ф.И.О. полностью</div>
    						<input type="text" name="booking_name_${userID}" value="" class="js-letters buyer-name" required>
    					</div>

    					<div class="booking-row cols-3 booking-data">
    						<div class="booking-col">
    							<div class="booking-placeholder">Дата рождения</div>
    							<div class="booking-date buyer-birthday">
    								<select class="booking-select__day buyer-day" name="birth-day">
                                        ${daySelect}
    								</select>
    								<select class="booking-select__month buyer-month" name="birth-month">
    									<option value="1">январь</option>
    									<option value="2">февраль</option>
    									<option value="3">март</option>
    									<option value="4">апрель</option>
    									<option value="5">май</option>
    									<option value="6">июнь</option>
    									<option value="7">июль</option>
    									<option value="8">август</option>
    									<option value="9">сентябрь</option>
    									<option value="10">октябрь</option>
    									<option value="11">ноябрь</option>
    									<option value="12">декабрь</option>
    								</select>
    								<select class="booking-select__year buyer-year" name="birth-year">
                                        ${yearSelect}
                                    </select>
    							</div>
    						</div>
    						<div class="booking-col">
    							<div class="booking-placeholder">Серия и номер паспорта</div>
    							<div class="booging-field">
    								<input type="text" name="passport_${userID}" value="" class="js-passport buyer-passport-number" required>
    							</div>
    						</div>
    						<div class="booking-col">
    							<div class="booking-placeholder">Дата выдачи паспорта</div>
    							<div class="booking-date buyer-passport">
    								<select class="booking-select__day buyer-passport-day" name="passport-day_${userID}">
                                        ${daySelect}
    								</select>
    								<select class="booking-select__month buyer-passport-month" name="passport-month_${userID}">
    									<option value="1">январь</option>
    									<option value="2">февраль</option>
    									<option value="3">март</option>
    									<option value="4">апрель</option>
    									<option value="5">май</option>
    									<option value="6">июнь</option>
    									<option value="7">июль</option>
    									<option value="8">август</option>
    									<option value="9">сентябрь</option>
    									<option value="10">октябрь</option>
    									<option value="11">ноябрь</option>
    									<option value="12">декабрь</option>
    								</select>
    								<select class="booking-select__year buyer-passport-year" name="passport-year_${userID}">
                                        ${yearSelect}
    								</select>
    							</div>
    						</div>
    					</div>

    					<div class="booking-field">
    						<div class="booking-placeholder">Тип питания</div>
    						<div class="booking-row">
    							<div class="booking-col">
    								<div for="food_${userID}_1" class="buyer-meal js-standard" data-meal="1">
    									<input class="cust_radio__input" id="food_${userID}_1" type="radio" name="food_${userID}" checked>
    									<label for="food_${userID}_1" class="cust_radio__label">стандартный</label>
    								</div>
    							</div>
    							<div class="booking-col">
    								<div for="food_${userID}_2" class="buyer-meal js-vegan" data-meal="2">
    									<input class="cust_radio__input" id="food_${userID}_2" type="radio" name="food_${userID}">
    									<label for="food_${userID}_2" class="cust_radio__label">вегетарианский (или иное)</label>
    								</div>
    							</div>
    						</div>
    					</div>

    					<div class="booking-field booking-comment">
    						<textarea class="buyer-meal-comment" name="comment_1" placeholder="Укажите, пожалуйста, существенные ограничения в питании, если есть (аллергия, непереносимость, веганское, вегетарианское и т.д.)"></textarea>
    					</div>
    		`,
        }).appendTo(bookedClients);
        bus.seats[userID] = {};
      }

      if (!sprinterShow) {
        $(".booking-client__sprinter").addClass("is-hidden");
      }

      if (!higerShow) {
        $(".booking-client__higer").addClass("is-hidden");
      }

      bookedTickets++;
    }

    $(".js-passport").mask("9999-999999");

    $(".js-letters").bind("change keyup input click", function () {
      if (this.value.match(/[^а-яА-Яa-zA-Z\s]/g)) {
        this.value = this.value.replace(/[^а-яА-Яa-zA-Z\s]/g, "");
      }
    });

    $(".js-vegan").off("click");
    $(".js-vegan").on("click", function () {
      $(this)
        .closest(".booking-client")
        .find(".booking-comment")
        .slideDown(100);
    });

    $(".js-standard").off("click");
    $(".js-standard").on("click", function () {
      $(this).closest(".booking-client").find(".booking-comment").slideUp(100);
    });

    $(".js-hide-data").on("change", function () {
      const $bookingData = $(this)
        .parents(".booking-client")
        .find(".booking-data");
      const $bookingDataInput = $bookingData.find("input");

      $bookingData.slideUp(100);

      $bookingDataInput.prop("disabled", true);
      $bookingDataInput.prop("required", false);
      $bookingDataInput.val("");
    });

    $(".js-show-data").on("change", function () {
      const $bookingData = $(this)
        .parents(".booking-client")
        .find(".booking-data");
      const $bookingDataInput = $bookingData.find("input");
      const passportDate = new Date(bus?.restrictions["passport"]),
        passportExpired = new Date() >= passportDate;

      $bookingData.slideDown(100);
      $bookingDataInput.prop("disabled", false);
      $bookingDataInput.prop("required", true);
    });

    if (sprinterVisible && sprinterShow) {
      sprinterArea.show();
      $(".booking-client__sprinter").removeClass("is-hidden");
    }
    bookedPlacesStatus();
  }

  function getPlaceBlank() {
    if (sprinterVisible) {
      attent.show();
      $(".booking-sprinter").show();
    }

    for (let i = 1; i <= totalTickets; i++) {
      bus.seats[String(i)] = {};

      if (!sprinterVisible) {
        higer.booked[String(i)] = 0;
      } else {
        sprinter.booked[String(i)] = 0;
        higer.booked[String(i)] = 0;
      }

      let daySelect = "";
      let yearSelect = "";

      for (let d = 1; d <= 31; d++) {
        daySelect += `<option value="${d}">${d}</option>`;
      }

      for (let y = new Date().getFullYear(); y >= 1901; y--) {
        yearSelect += `<option value="${y}">${y}</option>`;
      }

      $("<div/>", {
        class: "booking-client",
        // 'id': 'participant-' + i,
        html: `
						<div class="booking-client__row">
              <div class="booking-client__title" data-participant=${i}>Участник
                <div class="booking-client__num">${i}</div>
                <div class="booking-client__sprinter is-hidden">Sprinter: <span></span> место</div>
                <div class="booking-client__higer is-hidden">Higer: <span></span> место</div>
              </div>
              <div class="booking-client__radios">
                <div class="booking-row">
                  <div class="booking-col">
                    <label class="js-show-data">
                      <input class="cust_radio__input" id="data_${i}_1" type="radio" name="data_${i}" checked>
                      <div class="cust_radio__label">заполнить данные сейчас</div>
                    </label>
                  </div>
                  <div class="booking-col">
                    <label class="js-hide-data">
                      <input class="cust_radio__input" id="data_${i}_2" type="radio" name="data_${i}">
                      <div class="cust_radio__label">отправить куратору на e-mail</div>
                    </label>
                  </div>
                </div>
              </div>
            </div>

						<div class="booking-field booking-data">
							<div class="booking-placeholder">Ф.И.О. полностью</div>
							<input type="text" name="booking_name_${i}" class="js-letters buyer-name" value="" required>
						</div>

						<div class="booking-row cols-3 booking-data">
							<div class="booking-col">
								<div class="booking-placeholder">Дата рождения</div>
								<div class="booking-date buyer-birthday">
									<select class="booking-select__day buyer-day" name="birth-day">
                                        ${daySelect}
									</select>
									<select class="booking-select__month buyer-month" name="birth-month">
										<option value="1">январь</option>
										<option value="2">февраль</option>
										<option value="3">март</option>
										<option value="4">апрель</option>
										<option value="5">май</option>
										<option value="6">июнь</option>
										<option value="7">июль</option>
										<option value="8">август</option>
										<option value="9">сентябрь</option>
										<option value="10">октябрь</option>
										<option value="11">ноябрь</option>
										<option value="12">декабрь</option>
									</select>
									<select class="booking-select__year buyer-year" name="birth-year">
                                        ${yearSelect}
									</select>
								</div>
							</div>
							<div class="booking-col">
								<div class="booking-placeholder">Серия и номер паспорта</div>
								<div class="booging-field">
									<input type="text" name="passport_${i}" placeholder="" class="js-passport buyer-passport-number" required>
								</div>
							</div>
							<div class="booking-col">
								<div class="booking-placeholder">Дата выдачи паспорта</div>
								<div class="booking-date buyer-passport">
									<select class="booking-select__day buyer-passport-day" name="passport-day">
                                        ${daySelect}
									</select>
									<select class="booking-select__month buyer-passport-month" name="passport-month">
										<option value="1">январь</option>
										<option value="2">февраль</option>
										<option value="3">март</option>
										<option value="4">апрель</option>
										<option value="5">май</option>
										<option value="6">июнь</option>
										<option value="7">июль</option>
										<option value="8">август</option>
										<option value="9">сентябрь</option>
										<option value="10">октябрь</option>
										<option value="11">ноябрь</option>
										<option value="12">декабрь</option>
									</select>
									<select class="booking-select__year buyer-passport-year" name="passport-year">
                                        ${yearSelect}
									</select>
								</div>
							</div>
						</div>

						<div class="booking-field">
							<div class="booking-placeholder">Тип питания</div>
							<div class="booking-row">
								<div class="booking-col">
									<div for="food_${i}_1" class="buyer-meal js-standard" data-meal="1">
										<input class="cust_radio__input" id="food_${i}_1" type="radio" name="food_${i}" checked>
										<label for="food_${i}_1" class="cust_radio__label">стандартный</label>
									</div>
								</div>
								<div class="booking-col">
									<div for="food_${i}_2" class="buyer-meal js-vegan" data-meal="2">
										<input class="cust_radio__input" id="food_${i}_2" type="radio" name="food_${i}">
										<label for="food_${i}_2" class="cust_radio__label">вегетарианский (или иное)</label>
									</div>
								</div>
							</div>
						</div>

						<div class="booking-field booking-comment">
							<textarea class="buyer-meal-comment" name="comment_${i}_1" placeholder="Укажите, пожалуйста, существенные ограничения в питании, если есть (аллергия, непереносимость, веганское, вегетарианское и т.д.)"></textarea>
						</div>
			`,
      }).appendTo(bookedClients);
    }

    $(".js-vegan").off("click");
    $(".js-vegan").on("click", function () {
      $(this)
        .closest(".booking-client")
        .find(".booking-comment")
        .slideDown(100);
    });

    $(".js-standard").off("click");
    $(".js-standard").on("click", function () {
      $(this).closest(".booking-client").find(".booking-comment").slideUp(100);
    });

    $(".js-hide-data").on("change", function () {
      const $bookingData = $(this)
        .parents(".booking-client")
        .find(".booking-data");
      const $bookingDataInput = $bookingData.find("input");

      $bookingData.slideUp(100);

      $bookingDataInput.prop("disabled", true);
      $bookingDataInput.prop("required", false);
      $bookingDataInput.val("");
    });

    $(".js-show-data").on("change", function () {
      const $bookingData = $(this)
        .parents(".booking-client")
        .find(".booking-data");
      const $bookingDataInput = $bookingData.find("input");
      const passportDate = new Date(bus?.restrictions["passport"]),
        passportExpired = new Date() >= passportDate;

      $bookingData.slideDown(100);
      $bookingDataInput.prop("disabled", false);
      $bookingDataInput.prop("required", true);
    });

    $(".js-standard").on("click", function () {
      $(this).closest(".booking-client").find(".booking-comment").slideUp(100);
    });

    $(".js-passport").mask("9999-999999");

    $(".js-letters").bind("change keyup input click", function () {
      if (this.value.match(/[^а-яА-Яa-zA-Z\s]/g)) {
        this.value = this.value.replace(/[^а-яА-Яa-zA-Z\s]/g, "");
      }
    });
  }

  function freePlace(seat) {
    let number = seat.data("seat");
    let busType = seat.data("name");
    let userRemove = seat.data("user");
    if (bus.buses[busType]) {
      let bookedObject = bus.buses[busType].booked;
      let ticket = seat
        .parents(".booking-bus")
        .find(`.booking-ticket[data-ticket=${number}]`);
      let userPlace = $(
        `.booking-client__title[data-participant=${userRemove}] .booking-client__${busType}`
      );
      let userPlaceNum = userPlace.find("span");
      const bookedNumbers = $(`.booking-${busType} .seat.is-booked`).length;

      bookedObject[userRemove] = 0;
      seat
        .removeClass("is-booked")
        .attr("data-status", "free")
        .removeData("user");
      ticket.remove();
      userPlace.fadeOut();
      $(`.booking-${busType} .taken`).html(bookedNumbers - 1);
      bookingSubmit.hide();
    }
  }

  function bookPlace(seat) {
    let number = seat.data("seat");
    let busType = seat.data("name");

    if (bus.buses[busType]) {
      let bookedObject = bus.buses[busType].booked;
      let ticket = seat
        .parents(".booking-bus")
        .find(`.booking-ticket[data-ticket=${number}]`);
      const bookedNumbers = $(`.booking-${busType} .seat.is-booked`).length;

      let userNow = () => {
        for (let num in bookedObject) {
          if (bookedObject[num] === 0) return num;
        }
        return bookedNumbers + 1;
      };

      if (bookedNumbers < totalTickets) {
        let currentUser = userNow();
        bookedObject[currentUser] = number;
        let userPlace = $(
          `.booking-client__title[data-participant=${currentUser}] .booking-client__${busType}`
        );
        let userPlaceNum = userPlace.find("span");

        seat.addClass("is-booked").attr("data-status", "booked");
        seat.attr("data-user", currentUser);
        userPlaceNum.text(number);
        userPlace.removeClass("is-hidden").fadeIn();
        $(`.booking-${busType} .taken`).html(bookedNumbers + 1);
        addBuyerTicket(seat);
      } else {
        $(".hint-popup").fadeIn();
      }

      bookedPlacesStatus();
    }
  }

  function bookedPlacesStatus() {
    const sprinterBookedNumbers = $(`.booking-sprinter .seat.is-booked`).length;
    const higerBookedNumbers = $(`.booking-higer .seat.is-booked`).length;

    if (sprinterShow && higerShow) {
      if (sprinterVisible) {
        attent.show();
        if (
          sprinterBookedNumbers == higerBookedNumbers &&
          sprinterBookedNumbers == totalTickets
        ) {
          bookingSubmit.show();
        } else {
          bookingSubmit.hide();
        }
      } else {
        if (higerBookedNumbers == totalTickets) {
          bookingSubmit.show();
        } else {
          bookingSubmit.hide();
        }
      }
    }

    if (!sprinterShow && higerShow) {
      if (higerBookedNumbers == totalTickets) {
        bookingSubmit.show();
      } else {
        bookingSubmit.hide();
      }
    }
  }

  function addBuyerTicket(seat) {
    let number = seat.data("seat");
    let busType = seat.data("name");
    let user = seat.data("user");

    $("<div/>", {
      class: `${busType}-ticket booking-ticket`,
      "data-bus": busType,
      "data-ticket": number,
      "data-user": user,
      html: `
			<div class="booking-ticket__wrap">
				<div class="booking-ticket__place">
					<span class="booking-ticket__title">Место</span>
					<span class="booking-ticket__number"><i>${number}</i></span>
				</div>
				<div class="booking-ticket__close js-removeTicket"></div>
			</div>
			`,
    }).appendTo(`.booking-${busType} .booking-tickets`);

    $(".js-removeTicket").off();
    $(".js-removeTicket").on("click", function () {
      let seatNumber = $(this).closest(".booking-ticket").data("ticket");
      let seat = $(this)
        .parents(".booking-bus")
        .find(`[data-seat=${seatNumber}]`);
      freePlace(seat);
    });
  }

  $(".booking-form").off("submit");

  $(".booking-form").on("submit", function (e) {
    let ajaxUrl = $(this).attr("ajax-url");
    $(this).valid();
    e.preventDefault();

    if ($(this).validate().checkForm()) {
      pushUserInfo();
      postJsonData(bus, ajaxUrl);
    }
  });

  function pushUserInfo() {
    let isId = bus.seats?.["1"]?.ticketId;
    let buyerSprinterId = [];
    let buyerHigerId = [];

    if (isId) {
      for (let key of Object.keys(bus.seats)) {
        buyerSprinterId.push(bus.seats[key].ticketId.sprinter);
        buyerHigerId.push(bus.seats[key].ticketId.higer);
      }
    }

    bus.seats = {};
    $(".booking-client").each((index, el) => {
      let buyerName = $(el).find(".buyer-name").val();
      let buyerDay = $(el).find(".buyer-day").val();
      let buyerMonth = $(el).find(".buyer-month").val();
      let buyerYear = $(el).find(".buyer-year").val();
      let buyerPassport = $(el).find(".buyer-passport-number").val();
      let buyerPassportDay = $(el).find(".buyer-passport-day").val();
      let buyerPassportMonth = $(el).find(".buyer-passport-month").val();
      let buyerPassportYear = $(el).find(".buyer-passport-year").val();
      let buyerMeal = $(el)
        .find(".buyer-meal .cust_radio__input:checked")
        .parent()
        .data("meal");
      let buyerMealComment = $(el).find(".buyer-meal-comment").val();

      let seat = {
        fullName: buyerName,
        birthDay: buyerDay,
        birthMonth: buyerMonth,
        birthYear: buyerYear,
        passport: buyerPassport,
        passportDay: buyerPassportDay,
        passportMonth: buyerPassportMonth,
        passportYear: buyerPassportYear,
        foodType: buyerMeal,
        foodComment: buyerMealComment,
        ticketId: {
          sprinter: isId ? buyerSprinterId[index] : "",
          higer: isId ? buyerHigerId[index] : "",
        },
      };
      bus.seats[index + 1] = Object.assign(seat);
    });
  }

  // чистим дерево от старых элементов
  $("#booking g.seat")
    .removeClass("is-booked is-reserved is-occupied")
    .attr("data-status", "free");
  $("[data-name='Sprinter Front Seat']")
    .attr("data-status", "occupied")
    .addClass("is-occupied");
  $(".booking-ticket").remove();
  $(".booking-client").remove();

  $(".booking-bus .seat").off();
  $(".booking-bus .seat").on("click", function () {
    let seat = $(this);
    $(this).hasClass("is-booked") ? freePlace(seat) : bookPlace(seat);
  });

  $(".js-closeHintPopup").off("click");
  $(".js-closeHintPopup").on("click", function () {
    $(this).closest(".hint-popup").fadeOut();
  });

  $(".js-closeBookingPopup").off("click");
  $(".js-closeBookingPopup").on("click", function () {
    $(this).closest(".booking-popup").fadeOut();
  });

  getPlaceStatus();
}

$(document).on("click", ".js-closeThanksPopup", function () {
  // window.location.reload();
  $(".thanks-popup").fadeOut();
});
